import React from 'react';

const ArrowIcon = ({ fill = '#222222', rotate = '', type }) => {
  if (type === 'external') {
    return (
      <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
        <path
          d="M13.3203 2.66996C13.3203 1.35318 14.3884 0.285156 15.7052 0.285156C17.0221 0.285156 18.0902 1.35318 18.0902 2.66996C18.0902 3.98675 17.0221 5.05477 15.7052 5.05477C14.3884 5.05477 13.3203 3.98675 13.3203 2.66996Z"
          fill={fill}
        />
        <path
          d="M13.3211 5.05477H10.9749H2.51667V7.40085H9.31615L2.41016 14.3065L4.06888 15.9652L10.9749 9.05949V15.8587H13.3211V5.05477Z"
          fill={fill}
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        className={rotate}
      >
        <path
          d="M12.7982 6.04818L14.2496 7.49955L7.56589 14.1832L6.11452 12.7318L10.3207 8.52565L1.77654 8.52565L1.77654 6.47346L10.3207 6.47346L6.11452 2.26726L7.56589 0.81589L12.7982 6.04818Z"
          fill={fill}
        />
      </svg>
    );
  }
};

export default ArrowIcon;
